export default __webpack_public_path__ + "static/PromptIconOne-dc61ffcccf1ed772e68046810fe262e9.png";